import { ErrorBoundary } from "react-error-boundary";
import { Outlet } from "react-router-dom";
import * as React from "react";
import Box from "@mui/material/Box";

import { AdminNavbar } from "../shared-components/sidebar/SideBar";
import { BusinessDomainProvider } from "../contexts/BusinessDomainContext";

export default function AdminStickLayout(props: any): React.ReactElement {

  return (
    <BusinessDomainProvider>
      <Box sx={{ width: '100%', maxWidth: '100%', overflow: 'hidden', display: 'flex', minHeight: '100vh' }}>
        <AdminNavbar />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            minWidth: 0,
            minHeight: '100vh',
            pt: { xs: '56px', md: 0 },
            pl: { xs: 2, sm: 2.5, md: 3 },
            pr: { xs: 2, sm: 2.5, md: 3 },
            pb: { xs: 2, sm: 3, md: 4 },
            boxSizing: 'border-box',
          }}
        >
          <ErrorBoundary fallback={<div>Something went wrong</div>}>
            <Outlet />
          </ErrorBoundary>
        </Box>

        <Box
          component="style"
          dangerouslySetInnerHTML={{
            __html: `
            @keyframes shimmer {
              0% { background-position: -200% 0; }
              100% { background-position: 200% 0; }
            }
            @keyframes pulse {
              0%, 100% { transform: scale(1); }
              50% { transform: scale(1.05); }
            }
          `
          }}
        />
      </Box>
    </BusinessDomainProvider>
  );
}
